import { z } from "zod";

export type Category = {
  id: CategoryId;
  url: string;
  name: string;
  isSearchable: boolean;
};

export enum CategoryId {
  LegoSets = 1,
  Alcohol = 3,
  Watches = 2,
  Shoes = 4,
  Art = 5,
  Furniture = 6,
  Jewellery = 7,
  Coins = 8,
  ScaleModels = 9,
  Stamps = 10,
  FunkoPop = 11,
  VinylRecords = 12,
  MusicalInstruments = 13,
  Autographs = 14,
  Perfumes = 15,
  Cars = 16,
  Comics = 17,
  Postcards = 18,
  Weapons = 19,
  MagicTheGathering = 20,
  Pokemon = 21,
  SportsCards = 22,
  Books = 23,
  Handbags = 24,
  Porcelain = 25,
  MoviePosters = 26,
  BoardGames = 27,
  Banknotes = 28,
  Phaleristics = 29,
  Other = 30,
  LegoMinifigures = 31,
  StarWarsCards = 32,
}

export const CategoryId_Schema = z.enum(CategoryId);
